import { render } from "./AutomationsView.vue?vue&type=template&id=6f766d39&scoped=true&ts=true"
import script from "./AutomationsView.vue?vue&type=script&lang=ts"
export * from "./AutomationsView.vue?vue&type=script&lang=ts"

import "./AutomationsView.vue?vue&type=style&index=0&id=6f766d39&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f766d39"]])

export default __exports__